exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Testimonial.vue","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"minimize":false,"importLoaders":0,"alias":{"/assets":"/var/www/html/assets","/static":"/var/www/html/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e86941d8","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/Testimonial.vue
// module id = ./node_modules/css-loader/index.js?{"sourceMap":true,"minimize":false,"importLoaders":0,"alias":{"/assets":"/var/www/html/assets","/static":"/var/www/html/static"}}!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-e86941d8","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/Testimonial.vue
// module chunks = 2 3 4 5 6 7 8